export default __webpack_public_path__ + "static/media/newLogoRight.b672eb6e.png";